import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { appInfo } from '../config/appinfo'
import { useUser } from '../context/UserContext'

let started = false

export const HandoffPage = (): React.JSX.Element => {
  const navigate = useNavigate()
  const { login } = useUser()
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (started) return
    started = true

    const params = new URLSearchParams(window.location.hash.split('?')[1] ?? '')
    const ticket = params.get('ticket')

    if (!ticket) {
      navigate('/', { replace: true })
      return
    }

    ;(async () => {
      try {
        const res = await fetch(`${appInfo.apiDomain}${appInfo.apiBasePath}/handoff/redeem`, {
          method: 'POST',
          credentials: 'omit',
          headers: {
            'Content-Type': 'application/json',
            'st-auth-mode': 'header'
          },
          body: JSON.stringify({ ticket })
        })
        if (!res.ok) throw new Error(`redeem: ${res.status}`)

        await login()
        navigate('/dashboard', { replace: true })
      } catch (e) {
        console.error('[handoff] redeem failed:', e)
        setFailed(true)
        navigate('/login', { replace: true })
      }
    })()
  }, [])

  return (
    <div className="h-screen flex items-center justify-center bg-[#F5F5F5]">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-4 border-black border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-gray-600">
          {failed ? 'Could not sign you in — redirecting…' : 'Signing you in…'}
        </p>
      </div>
    </div>
  )
}
